import {
  Box,
  Button,
  Card,
  CardContent,
  Link,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useCrearUsuarioMutation } from "src/redux/api/usuariosApi";
import CustomDialog from "src/components/dialogo/CustomDialog";
import { TabPanel, a11yProps } from "src/components/Tabs/TabPanel";
import { useObtenerUnidadesAcademicasQuery } from "src/redux/api/unidadesAcademicasApi";
import { unidadAcademicaResponseToOpcionSelect } from "src/redux/api/types/unidades-academicas";
import TerminosYcondiciones from "./TerminosYcondiciones";
import FormularioUsuarioExterno from "./FormularioUsuarioExterno";
import FormularioUsuarioInterno from "./FormularioUsuarioInterno";

function Registro() {
  const [mostrarTerminosYcondiciones, setMostrarTerminosYcondiciones] =
    useState(false);

  const { data: unidadesAcademicasResponse } = useObtenerUnidadesAcademicasQuery();

  const [
    registrarUsuario,
    { isLoading: cargandoPeticion, isSuccess: usuarioCreadoExitosamente },
  ] = useCrearUsuarioMutation();

  const handleRegistro = (values: any) => {
    registrarUsuario(values)
      .unwrap()
      .then(() => {})
      .catch(() => {});
  };

  const verTerminosYcondiciones = () => {
    setMostrarTerminosYcondiciones(true);
  };

  const [value, setValue] = React.useState(0);

  const handleCambiarTab = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (usuarioCreadoExitosamente) {
    return (
      <Box
        sx={{
          width: "50%",
          minHeight: "100%",
          height: "100vh",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: { xs: 0, md: 3 },
        }}
        data-testid="registro-exitoso"
      >
        <Card
          variant="elevation"
          sx={{
            minWidth: "350px",
            padding: 3,
            marginY: 3,
            marginX: { xs: 2, md: 0 },
          }}
        >
          <CardContent>
            <Typography variant="h5" component="div" gutterBottom align="left">
              Registro de usuario exitoso
            </Typography>
            <Typography variant="body1" gutterBottom align="left">
              Usuario creado exitosamente, por favor espere a que un
              administrador active su cuenta y le envíe un correo de
              confirmación.
            </Typography>
            <Link href="/jupiter" underline="hover">
              <Typography variant="body1" gutterBottom align="left">
                Iniciar sesión
              </Typography>
            </Link>
          </CardContent>
        </Card>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: { xs: "100%", lg: "50%" },
        minHeight: "100%",
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: { xs: 0, md: 3 },
      }}
      data-testid="registro"
    >
      <Card
        variant="elevation"
        sx={{
          minWidth: { xs: "85%", md: "550px" },
          padding: { xs: 2, md: 3 },
          marginY: 3,
          marginX: { xs: 3, md: 0 },
        }}
      >
        <CardContent sx={{ overflow: "hidden" }}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleCambiarTab}
                aria-label="Tipos de usuarios"
              >
                <Tab
                  label={
                    <Typography
                      variant="body1"
                      align="center"
                      sx={{
                        textTransform: { xs: "capitalize", md: "uppercase" },
                      }}
                    >
                      Registro Usuario Institucional
                    </Typography>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  label={
                    <Typography
                      variant="body1"
                      align="center"
                      sx={{
                        textTransform: { xs: "capitalize", md: "uppercase" },
                      }}
                    >
                      Registro Usuario Externo
                    </Typography>
                  }
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <FormularioUsuarioInterno
                verTerminosYcondiciones={verTerminosYcondiciones}
                cargandoPeticion={cargandoPeticion}
                handleRegistro={handleRegistro}
                unidadesAcademicas={
                  unidadesAcademicasResponse
                    ? unidadesAcademicasResponse.map((unidad) =>
                        unidadAcademicaResponseToOpcionSelect(unidad),
                      )
                    : []
                }
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <FormularioUsuarioExterno
                verTerminosYcondiciones={verTerminosYcondiciones}
                cargandoPeticion={cargandoPeticion}
                handleRegistro={handleRegistro}
                unidadesAcademicas={
                  unidadesAcademicasResponse
                    ? unidadesAcademicasResponse.map((unidad) =>
                      unidadAcademicaResponseToOpcionSelect(unidad),
                      )
                    : []
                }
              />
            </TabPanel>
          </Box>
        </CardContent>
      </Card>
      <CustomDialog
        mostrar={mostrarTerminosYcondiciones}
        onClose={() => setMostrarTerminosYcondiciones(false)}
        contenido={<TerminosYcondiciones />}
        titulo={
          <Typography variant="h5" align="left" fontWeight={600}>
            POLÍTICAS DE TRATAMIENTO DE LA INFORMACIÓN PERSONAL
          </Typography>
        }
        acciones={
          <Button onClick={() => setMostrarTerminosYcondiciones(false)}>
            Cerrar
          </Button>
        }
        tamanioMaximo="md"
        fullWidth
      />
    </Box>
  );
}

export default Registro;
